import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { getEndClients, deleteEndClient, showEndClient, createEndClient } from '../../controllers/api_end_clients';
// (2026-08-02, ítem 31) Catálogo de terceros para el filtro de la lista.
import { getClients, normalizeClientsResponse } from '../../controllers/api_clients';
import { AuthContext } from "../../context/AuthContext";
import { getTypeTaxpayer } from "../../controllers/api_type_taxpayer";
import { encryptText } from '../../controllers/api';
import ModalConfirmation from "../Modals/ModalConfirmation";
import ModalEndClients from "./ModalEndClients";
import ModalImportPreviewClientsForm from "../Modals/ModalImportPreviewClients";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import JSZip from "jszip";
import * as XLSX from "xlsx";
const { read, utils } = XLSX;
import { formatDecimal, formatMoney, formatDate, formatDateTime, formatText } from "../../utils/formatters";
import Papa from 'papaparse';
window.JSZip = JSZip;
DataTable.use(DT);

function ListEndClients() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenClients, setModalOpenClients] = useState(false);
  const [clientIdToDeactivate, setClientIdToDeactivate] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importData, setImportData] = useState([]);
  const { user } = useContext(AuthContext);
  const rol = user?.rol;
  // (2026-08-02, bug P2) `var responseCache = useState(false)` ELIMINADO: era
  // un uso INVÁLIDO de useState (devuelve el par [valor, setter], nunca los
  // datos) y encima se reasignaba en cada render. Alimentaba una búsqueda "en
  // memoria" sobre la ÚLTIMA página cargada. Con la tabla en modo cliente
  // (serverSide:false + request_type='all') DataTables busca y pagina sobre el
  // conjunto completo y ese caché ya no existe.
  //
  // (2026-08-02, ítem 31) Filtro por TERCERO. Visible para admin, auditor y
  // usuarios de una empresa EMISORA. "" = clientes propios (comportamiento
  // actual); un id => se consulta con empresa_id=<tercero>.
  const [terceros, setTerceros] = useState([]);
  const [terceroFiltro, setTerceroFiltro] = useState("");
  // El filtro se lee desde el `ajax` de DataTables, que se registra UNA vez al
  // montar: un ref evita la closure obsoleta sin recrear la tabla.
  const puedeFiltrarTerceros =
    rol === 'admin' || rol === 'auditor' || user?.es_emisor === true;

  // (ítem 31) Catálogo de terceros para el desplegable del filtro.
  useEffect(() => {
    if (!puedeFiltrarTerceros) return;
    let cancelado = false;
    (async () => {
      try {
        const resp = await getClients({ es_tercero: true, activo: true });
        if (!cancelado) setTerceros(normalizeClientsResponse(resp));
      } catch (e) {
        // No bloqueante: sin catálogo, el filtro queda solo con "Todos (propios)".
        console.warn("No se pudieron cargar los terceros para el filtro", e);
      }
    })();
    return () => { cancelado = true; };
  }, [puedeFiltrarTerceros]);

  // (ítem 31 · FIX P0+H-09 QA 2026-08-02) NADA de ajax.reload() (con ajax
  // async DataTables hace .abort() sobre una Promise y revienta la vista) y
  // NADA de refs para el filtro (llegaban desfasados un render tras el
  // remontaje). Patrón ListProducts: remontar por `key` y que el closure del
  // ajax lea el ESTADO.

  // DataTable listeners
  useEffect(() => {
    const table = $("#ListClientDt").DataTable();

    $("#ListClientDt tbody").on("click", "button.btn-edit", function () {
      const id = $(this).data("id");
      redirectToEdit(id);
    });

    $("#ListClientDt tbody").on("click", "button.btn-delete", function () {
      const id = $(this).data("id");
      const nombre = $(this).data("nombre");
      const action = $(this).data("action");
      handleOpenModal(id, nombre, action);
    });

    $("#ListClientDt tbody").on("click", "button.btn-view", function () {
      const id = $(this).data("id");
      console.log('btn-view: ', id);
      handleOpenModalClients(id);
    });

    return () => {
      $("#ListClientDt tbody").off("click", "button.btn-edit");
      $("#ListClientDt tbody").off("click", "button.btn-delete");
      $("#ListClientDt tbody").off("click", "button.btn-view");
    };
  }, []);

  const redirectToEdit = (id) => {
    const hash = encryptText(id.toString());
    // (FIX P1 QA 2026-08-02) La ruta registrada en App.js es /clients/edit
    // (no existe /endclients/edit — daba 404).
    navigate(`/clients/edit?id=${encodeURIComponent(hash)}`);
  };

  const redirectToCreate = () => navigate(`/clients/create`);

  const handleAction = async (id, action) => {
    try {
      let data;
      if (action === 'delete') {
        data = await deleteEndClient(id);
      } /*else {
        data = await activateClient(id);
      }*/
      toast.success(data.mensaje, { onClose: () => setTimeout(() => refreshClients(), 3000) });
    } catch {
      toast.error("Error al actualizar el cliente");
    }
  };

  const refreshClients = async () => location.reload(true);

  const handleConfirm = () => {
    if (clientIdToDeactivate) {
      handleAction(clientIdToDeactivate.id, clientIdToDeactivate.action);
      setModalOpen(false);
    }
  };

  const handleOpenModal = (id, nombre, action) => {
    setClientIdToDeactivate({ id, nombre, action });
    setModalOpen(true);
  };

  const handleCloseModal = () => setModalOpen(false);

  const handleOpenModalClients = async (id) => {
    try {
      console.log('handleOpenModalClients-id: ', id);
      const data = await showEndClient(id);
      console.log('handleOpenModalClients-data: ', data);
      setClientIdToDeactivate(data);
      setModalOpenClients(true);
    } catch {
      toast.error("Error al consultar los datos del cliente.");
    }
  };

  const handleCloseModalClients = () => setModalOpenClients(false);

  // lectura del archivo e invocación de la modal
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    const reader = new FileReader();

    if (ext === "csv") {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          setImportData(results.data);
          setIsImportModalOpen(true);
        },
      });
    } else if (ext === "xlsx" || ext === "xls") {
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = utils.sheet_to_json(ws);
        setImportData(data);
        setIsImportModalOpen(true);
      };
      reader.readAsBinaryString(file);
    } else {
      toast.error("Formato no soportado. Usa CSV o Excel.");
    }
    e.target.value = "";
  };

  // confirmación desde la modal (importa todos los clientes)
  const handleConfirmImport = async (clientes) => {
    try {
      for (let client of clientes) {
        await createEndClient(client);
      }
      toast.success("Clientes importados correctamente");
      setIsImportModalOpen(false);
      refreshClients();
    } catch (err) {
      console.error("Error al importar clientes:", err);

      // Detectar mensajes devueltos por el backend
      let backendMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Error desconocido al importar clientes";

      if (Array.isArray(err?.response?.data)) {
        backendMsg = err.response.data
          .map((e, i) => `Fila ${i + 1}: ${e.message || e.error || JSON.stringify(e)}`)
          .join("\n");
      }

      toast.error(backendMsg, {
        autoClose: 3000,
        style: { whiteSpace: "pre-line" },
      });
    }
  };

  // API de selects
  const apiSelects = {
    tipo_contribuyente_id: async () => {
      const data = await getTypeTaxpayer();
      return data || [];
    },
  };

  // Validaciones básicas
  const validationRules = {
    rif: (v) => ({ valid: !!v, message: "El RIF es obligatorio" }),
    nombre: (v) => ({ valid: !!v, message: "El nombre de empresa es obligatorio" }),
    telefono: (v) => ({ valid: !!v, message: "El telefono es obligatorio" }),
    email: (v) => ({ valid: !!v, message: "El correo electronico es obligatorio" }),
    direccion: (v) => ({ valid: !!v, message: "La direccion es obligatoria" }),
    //tipo_contribuyente_id: (v) => ({ valid: !!v, message: "Debe seleccionar el tipo de contribuyente" }),
    //region: (v) => ({ valid: v && v !== "#", message: "Seleccione una región" }),
    //estado: (v) => ({ valid: v && v !== "#", message: "Seleccione un estado" }),
  };

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Header */}
            <div className="rounded-t bg-white mb-0 px-6 py-6 flex justify-between items-center border-b">
              <h6 className="text-blueGray-700 text-xl font-bold">Lista de Clientes</h6>

              <div className="flex items-center space-x-3">
                {/* (2026-08-02, ítem 31) Filtro por TERCERO: las empresas
                    emisoras, admin y auditores necesitan ver los clientes
                    finales de sus terceros. "Todos (propios)" = el
                    comportamiento anterior (clientes de la propia empresa). */}
                {puedeFiltrarTerceros && (
                  <div className="flex items-center gap-2">
                    <label className="text-blueGray-700 font-bold whitespace-nowrap">Tercero:</label>
                    <select
                      id="filtro_tercero_clientes"
                      className="border p-2 rounded"
                      value={terceroFiltro}
                      onChange={(e) => setTerceroFiltro(e.target.value)}
                    >
                      <option value="">Todos (propios)</option>
                      {terceros.map((t) => (
                        <option key={t.id} value={t.id}>
                          {(t.nombre_empresa || t.denominacion_comercial || t.rif || 'Empresa sin nombre')}{(t.rif && (t.nombre_empresa || t.denominacion_comercial)) ? ` (${t.rif})` : ''}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {(rol != "visor" &&  rol != 'auditor') && (
                  <button
                    className="bg-twilight-indigo-600 hover:bg-twilight-indigo-500 text-white font-bold py-2 px-4 rounded"
                    onClick={redirectToCreate}>
                    Crear Cliente
                  </button>
                )}
                {/* botón de importación */}
                {rol === "admin" && (
                  <label className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded cursor-pointer">
                    Importar Excel/CSV
                    <input
                      type="file"
                      accept=".csv,.xlsx,.xls"
                      className="hidden"
                      onChange={handleFileUpload}
                    />
                  </label>
                )}
              </div>
            </div>

            {/* DataTable */}
            <div className="block w-full overflow-x-auto px-4 py-4">
              <DataTable
                id="ListClientDt"
                key={`endcli-${terceroFiltro}`}
                className="table-auto w-full text-left"
                columns={[
                  { title: "RIF", data: "rif", className: "dt-center",render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Razón social", data: "nombre", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Denominación comercial", data: "denominacion_comercial", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Correo electrónico", data: "email", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Teléfono", data: "telefono", className: "dt-center", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  //{ title: "Tipo de contribuyente", data: "tipo_contribuyente.nombre" },
                  { title: "Dirección", data: "direccion", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Tipo de contribuyente", className: "dt-center", data: "tipo_contribuyente", render: (data, type, row) => {
                      return formatText(data?.nombre || '');
                    }
                  },
                  { title: "Zona", data: "zona", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Estado", data: "estado", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  { title: "Región", data: "region", render: (data, type, row) => {
                      return formatText(data);
                    }
                  },
                  {
                    // (2026-08-02, ítem 28-iv) "Tipo de cliente" (es_rif) SE
                    // ELIMINA de la UI: era un booleano que el usuario elegía y
                    // que hoy DERIVA el backend de la fila del Catálogo 7. En su
                    // lugar se muestra el dato real: el tipo de identificación,
                    // que ya viaja anidado en el payload (ClienteSchema
                    // .tipo_identificacion -> {id, codigo, descripcion, es_rif}).
                    title: "Tipo de identificación",
                    data: "tipo_identificacion",
                    className: "dt-center",
                    render: (data, type, row) => {
                      if (!data || !data.codigo) return '—';
                      return formatText(`${data.codigo} — ${data.descripcion || ''}`);
                    }
                  },
                  {
                    title: "Condición",
                    data: "activo",
                    className: "dt-center",
                    render: (data, type, row) => {
                      if (!data){
                        return '<i class="fas fa-circle text-red-500 mr-2"></i> ' + formatText('Inactivo');
                      }else{
                        return '<i class="fas fa-circle text-emerald-500 mr-2"></i> ' + formatText('Activo');
                      }
                    }
                  },
                  {
                    // (remediación FE-A, P2) `className: 'no-export'` estaba
                    // DUPLICADA en este objeto (clave repetida): la primera se
                    // descartaba en silencio y esbuild/eslint lo reportaban.
                    title: "Acciones",
                    data: "activo",
                    className: 'no-export',
                    render: (data, type, row) => {
                      const viewBtn = `<button class="btn-view px-2 py-1 text-gray-700" data-id="${row.id}"><i class="fa-solid fa-lg fa-expand"></i></button>`;
                      const editBtn = `<button class="btn-edit px-2 py-1 text-blue-600" data-id="${row.id}"><i class="fa-solid fa-lg fa-pen-to-square"></i></button>`;
                      const toggleBtn = data
                        ? `<button class="btn-delete px-2 py-1 text-red-600" data-id="${row.id}" data-nombre="${row.nombre}" data-action="delete"><i class="fa-regular fa-rectangle-xmark fa-lg"></i></button>`
                        : `<button class="btn-delete px-2 py-1 text-green-600" data-id="${row.id}" data-nombre="${row.nombre}" data-action="active"><i class="fa-regular fa-square-check fa-lg"></i></button>`;
                      if (rol == 'visor' || rol == 'auditor'){
                        return `<div style="display:flex;justify-content:center;align-items:center;gap:0.25rem;white-space:nowrap;">${viewBtn}</div>`;
                      }else{
                        return `<div style="display:flex;justify-content:center;align-items:center;gap:0.25rem;white-space:nowrap;">${viewBtn}${editBtn}${toggleBtn}</div>`;
                      }
                    },
                  },
                ]}
                options={{
                  columnDefs:[{
                    // Índices ocultos: 5 Dirección, 7 Zona, 8 Estado, 9 Región.
                    // (2026-08-02, ítem 28-iv) El 10 (antes "Tipo de cliente",
                    // oculto) pasa a ser "Tipo de identificación" y se muestra:
                    // es el dato que el usuario pidió ver en la lista.
                    targets: [5, 7, 8, 9],
                    visible: false,
                    searchable: true // siguen siendo buscables
                  }],
                  // (2026-08-02, bug P2 "listas truncadas") serverSide:false +
                  // request_type='all': antes la tabla decía serverSide:true pero
                  // la búsqueda se hacía EN MEMORIA sobre la última página, así
                  // que solo se buscaba/ordenaba dentro de 20 filas. Ahora el
                  // backend entrega el conjunto completo (client_routes.py:
                  // 201-214) y DataTables pagina, ordena y busca sobre TODO.
                  serverSide: false,
                  // (remediación FE-A, P2) `processing` se declaraba dos veces
                  // en este mismo objeto de opciones; se conserva una sola,
                  // junto al resto de flags de la tabla (más abajo).
                  ajax: async (dataTablesParams, callback) => {
                    try {
                      const query = { request_type: 'all', page: 1, per_page: 5000 };
                      // (ítem 31) Filtro por tercero: el backend acepta
                      // `empresa_id` (client_routes.py:107-114) y valida que el
                      // tercero pertenezca al emisor del token (:131-151).
                      // (FIX H-09 QA 2026-08-02) Se lee el ESTADO, no un ref:
                      // al remontar por `key` este closure se recrea con el
                      // valor nuevo (patrón ListProducts). El ref se leía ANTES
                      // de que el efecto del padre lo actualizara -> filtro
                      // desfasado una selección.
                      if (terceroFiltro) query.empresa_id = terceroFiltro;

                      const response = await getEndClients(query);
                      const arr = Array.isArray(response) ? response : (response?.data || []);

                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: arr.length,
                        recordsFiltered: arr.length,
                        data: arr,
                      });
                    } catch (err) {
                      console.error("Error cargando la lista de clientes:", err);
                      toast.error("No se pudo cargar la lista de clientes.");
                      callback({
                        draw: dataTablesParams.draw,
                        recordsTotal: 0,
                        recordsFiltered: 0,
                        data: [],
                      });
                    }
                  },
                  dom: //B = Buttons, l = LengthMenu (mostrar X registros), f = Filtro (search), t = Tabla, i = Info (mostrando de X a Y de Z), p = Paginación
                    "<'row'<'col-sm-12 text-start'B>>" +                // Fila 2: botones ocupando todo el ancho
                    "<'row'<'col-sm-6 text-end'l><'col-sm-6'f>>" +    // Fila 1: lengthMenu izquierda, filtro derecha
                    "<'row'<'col-sm-12'tr>>" +               // Fila 3: tabla
                    "<'row'<'col-sm-5 text-start'i><'col-sm-7 text-end'p>>",     // Fila 4: info izquierda, paginación derecha
                  searching: true,
                  processing: true,
                  scrollX: true,
                  autoWidth: false,
                  pageLength: 20,         // cantidad inicial por página
                  lengthMenu: [20, 50, 100], // opciones en el desplegable, false para oculta el selector
                  buttons: [
                    {
                      extend: "collection",
                      text: "Exportar",
                      className: "bg-slate-700 hover:bg-slate-600 text-white font-bold py-2 px-4 rounded",
                      buttons: [
                        {
                          extend: "copyHtml5",
                          text: "Copiar",
                          title: "Lista de clientes"   // nombre del documento en el portapapeles
                        },
                        {
                          extend: "excelHtml5",
                          text: "Excel",
                          title: "Lista de clientes",  // título dentro del archivo
                          filename: "Lista_clientes",   // nombre del archivo generado (sin extensión)
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                        {
                          extend: "csvHtml5",
                          text: "CSV",
                          title: "Lista de clientes",
                          filename: "Lista_clientes",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                        {
                          extend: "pdfHtml5",
                          text: "PDF",
                          title: "Lista de clientes",
                          filename: "Lista_clientes",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          },
                          orientation: "landscape",
                          //orientation: "landscape",   // opcional
                          //pageSize: "A4"              // opcional
                        },
                        {
                          extend: "print",
                          text: "Imprimir",
                          title: "Lista de clientes",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          }
                        },
                        {
                          text: "Exportar todo (Excel)",
                          exportOptions: {
                            columns: ':not(.no-export)'
                          },
                          action: async function (e, dt, node, config) {
                            const exportButton = node;
                            try {
                              const allData = [];
                              let page = 1;
                              // (remediación FE-A, P2) `const per_page = dt.length`
                              // era código muerto: el bucle fija per_page=100 en
                              // cada iteración.
                              let totalPages = 1;

                              // Mostrar mensaje de progreso
                              $(exportButton).text("Cargando...").prop("disabled", true).attr("style", "pointer-events: none;");
                              const query = { page, per_page: 100 };
                              // (ítem 31) La exportación respeta el filtro de tercero.
                              if (terceroFiltro) {
                                query.empresa_id = terceroFiltro;
                              }
                              // Cargar todas las páginas hasta completar total_pages
                              do {
                                query.page = page;
                                query.per_page = 100;
                                const response = await getEndClients(query);
                                const { data, total_pages } = response;

                                allData.push(...data);
                                totalPages = total_pages;
                                page++;
                              } while (page <= totalPages);

                              // Convertimos a Excel con xlsx
                              const wb = utils.book_new();
                              const ws = utils.json_to_sheet(allData.map(item => ({
                                "RIF": formatText(item.rif),
                                "Razón social": formatText(item.nombre),
                                "Denominación comercial": formatText(item.denominacion_comercial),
                                "Correo electrónico": formatText(item.email),
                                "Teléfono": formatText(item.telefono),
                                "Dirección": formatText(item.direccion),
                                "Zona":formatText(item.zona),
                                "Estado": formatText(item.estado),
                                "Región": formatText(item.region),
                                "Tipo de contribuyente":formatText(item.tipo_contribuyente?.nombre || ''),
                                // (ítem 28-iv) Sustituye a "Tipo de cliente" (es_rif).
                                "Tipo de identificación": item.tipo_identificacion?.codigo
                                    ? formatText(`${item.tipo_identificacion.codigo} — ${item.tipo_identificacion.descripcion || ''}`)
                                    : '—',
                                "Condición": formatText(item.activo
                                    ? "Activo"
                                    : "Inactivo")
                              })));

                              utils.book_append_sheet(wb, ws, "Auditoría");

                              const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                              const blob = new Blob([wbout], { type: "application/octet-stream" });
                              const link = document.createElement("a");
                              link.href = URL.createObjectURL(blob);
                              link.download = "Clientes.xlsx";
                              link.click();

                              $(exportButton).text("Exportar todo (Excel)").prop("disabled", false).attr("style", "pointer-events: auto;");;
                              toast.success("Archivo exportado correctamente.");
                            } catch (error) {
                              $(exportButton).text("Exportar todo (Excel)").prop("disabled", false).attr("style", "pointer-events: auto;");;
                              console.error("Error al exportar:", error);
                              toast.error("Error al exportar los datos.");
                            }
                          }
                        }
                      ]
                    }
                  ],
                  language: {
                    decimal: ",",
                    thousands: ".",
                    lengthMenu: "Mostrar _MENU_ registros por página",
                    zeroRecords: "No se encontraron resultados",
                    info: "Mostrando de _START_ a _END_ de _TOTAL_ registros",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrado de _MAX_ registros totales)",
                    search: "Buscar:",
                    paginate: {
                      first: "Primero",
                      last: "Último",
                      next: "Siguiente",
                      previous: "Anterior"
                    }
                  },
                }}
              />

              {/* Modales */}
              <ModalConfirmation
                isOpen={modalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirm}
                message={`¿Estás seguro de que deseas ${
                  clientIdToDeactivate?.action === "delete" ? "desactivar" : "activar"
                } al cliente ${clientIdToDeactivate?.nombre || ""}?`}
              />
              <ModalEndClients
                isOpen={modalOpenClients}
                onClose={handleCloseModalClients}
                message={clientIdToDeactivate}
              />

              {/* Modal de previsualización */}
              {isImportModalOpen && (
                <ModalImportPreviewClientsForm
                  isOpen={isImportModalOpen}
                  onClose={() => {
                    setIsImportModalOpen(false);
                    setImportData([]);
                  }}
                  onConfirm={handleConfirmImport}
                  data={importData}
                  rol={rol}
                  apiSelects={apiSelects}
                  validationRules={validationRules}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListEndClients;